import ReactGA from 'react-ga';
const initGA = () => {       
    ReactGA.initialize('UA-200772012-1'); // put your tracking id here
} 

export default initGA;